import React from 'react';
import { Box } from 'investira.react.components';

/**
 * Mantém o comportamento responsivo comum às colunas de destaque.
 *
 * @param {Object} pProps Propriedades do componente.
 * @param {React.ReactNode} pProps.children Conteúdo exibido na coluna.
 * @param {Object} pProps.columns Colunas ocupadas nos breakpoints intermediário e amplo.
 * @returns {JSX.Element}
 */
function AtivoHighlightColumn(pProps) {
  const { children, columns = {} } = pProps;

  return (
    <Box
      sx={{
        display: 'flex',
        minWidth: 0,
        gridColumn: {
          xs: '1 / -1',
          ...columns
        }
      }}>
      {children}
    </Box>
  );
}

export default AtivoHighlightColumn;
